import { useMutation, useQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { FaAngleDown } from 'react-icons/fa';
import { MdClose, MdOutlineDone } from 'react-icons/md';
import { HiTag } from 'react-icons/hi2';
import { useSelector } from 'react-redux';
import Modal from 'react-responsive-modal';
import Select, { components } from 'react-select';
import { GET_TEAMS } from '../../../apollo/Queries';
import { CREATE_UPDATE_TAG } from '../../../apollo/Mutations';
import toast from 'react-hot-toast';
import { validFirstChercterAlsoNuber } from '../../../Utils/ValidationCheck';

// const colorCode = ['#345756', '#4B807C', '#64AAA5', '#7ED6CF', '#7954BC', '#9A7ECD'];
const colorCode = ['#318FFF', '#2772CC', '#2440BD', '#1D3397', '#5929AB', '#351967'];
const CreateTag = ({ type = 'create', activeTag, isOpen, onClose, search, setSearch, all_tags, setAll_tags, select_tag }) => {
    const { user } = useSelector(state => state.message);
    const [loader, setLoader] = useState(false);
    const [uniqName, setUniqName] = useState(true);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [teams, setTeams] = useState([]);
    const [selectedTeams, setSelectedTeams] = useState([]);
    const [selectedColor, setSelectedColor] = useState('#318FFF');
    const [searchQuery, setSearchQuery] = useState('');
    const [isChanged, setIsChanged] = useState(false);

    useEffect(() => {
        if (type === 'edit') {
            if (activeTag) {
                setSelectedColor(activeTag?.tag_color || '#318FFF');
                setSearchQuery(activeTag?.title || '');
            }
        }
    }, [type, activeTag]);

    useEffect(() => {
        setSearchQuery(search);
    }, [search]);

    useEffect(() => {
        if (searchQuery) {
            let isUniq = all_tags.filter(t => t.title?.toLowerCase() === searchQuery?.toLowerCase());
            if (isUniq.length) {
                if (type === 'edit') {
                    setUniqName(true);
                } else {
                    setUniqName(false);
                }
            } else {
                setUniqName(true);
            }
        }
    }, [searchQuery]);

    useQuery(GET_TEAMS, {
        variables: { user_id: user?.id },
        onCompleted: (data) => {
            const options = data.teams.map(team => ({
                value: team.team_id,
                label: team.team_title
            }));
            if (options.length === 1) {
                setSelectedTeams(options);
            }
            setTeams(options);
        }
    });

    useEffect(() => {
        if (type === 'edit' && activeTag) {
            const hasChanges =
                searchQuery !== (activeTag?.title || '') ||
                selectedColor !== (activeTag?.tag_color || '#318FFF') ||
                JSON.stringify(selectedTeams.map(t => t.value)) !== JSON.stringify(activeTag?.team_list || []);
            setIsChanged(hasChanges);
        } else {
            setIsChanged(searchQuery?.trim() !== '' || selectedTeams.length > 0);
        }
    }, [searchQuery, selectedColor, selectedTeams, type, activeTag]);

    const selectTeams = (e) => {
        setSelectedTeams(e);
    };

    const [create_tag] = useMutation(CREATE_UPDATE_TAG);

    const createTag = async () => {
        setLoader(true);
        try {
            let d = {
                title: searchQuery?.trim()?.toUpperCase() || "",
                tagged_by: user?.id || "",
                tag_type: "public",
                tag_color: selectedColor || "#318FFF",
                team_list: Array.isArray(selectedTeams) ? selectedTeams.map(m => m.value) : []
            };

            if (type === 'edit') {
                d.tag_id = activeTag.tag_id;
            }

            if (!d.title) {
                toast.error("Tag title is required.");
                setLoader(false);
                return;
            }

            let { data } = await create_tag({
                variables: { input: d }
            });

            if (data?.create_update_tag?.status) {
                setSearchQuery('');
                setSearch('');
                if (type === 'edit') {
                    setAll_tags(prev => [...prev.map(t => t.tag_id === activeTag?.tag_id ? { ...t, title: searchQuery?.trim()?.toUpperCase(), tag_color: selectedColor, team_list: data.create_update_tag.tag.team_list, team_list_name: data.create_update_tag.tag.team_list_name } : t)]);
                } else {
                    setAll_tags(prev => [data.create_update_tag.tag, ...prev]);
                    if (select_tag) select_tag(data.create_update_tag.tag);
                }
                toast.success(data.create_update_tag.message);
                setLoader(false);
                onClose(false);
            } else {
                toast.error("Failed to create tag.");
                setLoader(false);
            }
        } catch (error) {
            console.error("🚀 ~ createTag ~ error:", error);
            toast.error("Failed to create tag. Please try again.");
            setLoader(false);
        }
    };

    const handleInputChange = (e) => {
        const { value } = e.target;

        if (value === '') {
            setSearchQuery(value);
            return;
        }

        if (validFirstChercterAlsoNuber(value)) {
            console.warn('Invalid input for title');
            return;
        }

        const trimmedValue = value.trimStart();

        if (!trimmedValue) {
            console.warn('Title cannot be empty or contain only spaces');
            return;
        }

        setSearchQuery(trimmedValue);
    };

    const customStyles = {
        control: base => ({
            ...base,
            minHeight: 46,
            backgroundColor: "white",
            border: '1px solid #D1D5DB',
            borderRadius: '8px',
            boxShadow: 'none',
            '&:hover': {
                borderColor: '#9CA3AF',
            },
            '&:focus-within': {
                borderColor: '#14B8A6',
                boxShadow: '0 0 0 3px rgba(20, 184, 166, 0.1)',
            },
        }),
        placeholder: defaultStyles => ({
            ...defaultStyles,
            color: '#9CA3AF',
            fontSize: '14px',
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#F3F4F6',
            borderRadius: '6px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#374151',
            fontSize: '13px',
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: '#6B7280',
            borderRadius: '0 6px 6px 0',
            '&:hover': {
                backgroundColor: '#E5E7EB',
                color: '#374151',
            },
        }),
        menuPortal: provided => ({ ...provided, zIndex: 9999 }),
        menu: provided => ({ ...provided, zIndex: 9999, borderRadius: '8px', marginTop: '4px' }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#14B8A6' : state.isFocused ? '#F3F4F6' : 'white',
            color: state.isSelected ? 'white' : '#374151',
            fontSize: '14px',
            cursor: 'pointer',
        }),
        clearIndicator: (base, state) => ({
            ...base,
            cursor: 'pointer',
            color: state.isFocused ? '#14B8A6' : '#9CA3AF',
        }),
        indicatorSeparator: () => { },
    };

    const handleColorSelect = (color) => {
        setSelectedColor(color);
    };

    const ClearIndicator = (props) => {
        const {
            getStyles,
            innerProps: { ref, ...restInnerProps },
        } = props;

        return (
            <div {...restInnerProps} ref={ref} style={getStyles('clearIndicator', props)}>
            </div>
        );
    };

    const DropdownIndicator = props => {
        return (
            <components.DropdownIndicator {...props}>
                <FaAngleDown className='rightArrowSelectIcon' style={{
                    color: '#858fa3',
                    transition: 'transform 0.2s',
                    transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                }} />
            </components.DropdownIndicator>
        );
    };

    const handleClose = () => {
        onClose(false);
        setSearch('');
    };

    return (
        <Modal
            open={isOpen}
            container={document.getElementById('root')}
            onClose={handleClose}
            center
            closeIcon={<MdClose className="text-2xl text-[#8A92A1] hover:text-teal-600 dark:text-[#B1B7C1] dark:hover:text-white transition-colors" />}
            focusTrapped={false}
            classNames={{
                overlay: 'customOverlay bg-black/50 backdrop-blur-sm',
                modal: 'customModal !rounded-xl !shadow-2xl !p-0 !overflow-hidden bg-white dark:bg-[#181E28]',
            }}
        >
            {/* Header */}
            <div className="px-6 flex gap-3 items-center py-4 border-b border-[#E5E7EB] dark:border-[#303B4F] bg-gradient-to-r from-[#F9FAFB] to-white dark:from-[#1F2937] dark:to-[#181E28]">
                <div className="w-10 h-10 rounded-lg bg-teal-100 dark:bg-teal-500/20 flex items-center justify-center">
                    <HiTag className="w-6 h-6 text-teal-600 dark:text-teal-400" />
                </div>
                <div>
                    <h4 className="text-lg font-bold text-teal-600 dark:text-white">
                        {type === 'edit' ? 'Edit tag' : 'Create new tag'}
                    </h4>
                    <p className="text-xs text-[#8A92A1] dark:text-[#B1B7C1]">
                        {type === 'edit' ? 'Update your tag information' : 'Create a new tag for your teams'}
                    </p>
                </div>
            </div>

            {/* Body */}
            <div className="p-6 bg-[#FAFBFC] dark:bg-[#0C0F14] space-y-5">
                {/* Tag Name */}
                <div className="space-y-1.5">
                    <label className="text-xs font-semibold text-[#374151] dark:text-[#E5E7EB] tracking-wide">
                        Tag name <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        placeholder="Enter tag name"
                        value={searchQuery}
                        onChange={handleInputChange}
                        className="w-full pl-4 pr-4 py-2.5 text-sm bg-white dark:bg-[#242C3B] border border-[#D1D5DB] dark:border-[#374151] rounded-lg focus:outline-none focus:ring-1 focus:ring-teal-500/20 focus:border-teal-500 text-[#111827] dark:text-white placeholder-[#9CA3AF] transition-all duration-200"
                        autoFocus
                    />
                    {(!uniqName && type !== 'edit') && (
                        <span className="text-xs text-red-500">Tag name already exists.</span>
                    )}
                </div>

                {/* Color Selection */}
                <div className="space-y-1.5">
                    <label className="text-xs font-semibold text-[#374151] dark:text-[#E5E7EB] tracking-wide">
                        Color
                    </label>
                    <div className='flex gap-2 flex-wrap'>
                        {colorCode.map(v => (
                            <div
                                key={v}
                                className={`w-10 h-10 relative rounded-lg cursor-pointer transition-transform hover:scale-105 ${selectedColor === v ? 'ring-2 ring-offset-2 ring-teal-500' : ''}`}
                                style={{ backgroundColor: v }}
                                onClick={() => handleColorSelect(v)}
                            >
                                {selectedColor === v && (
                                    <MdOutlineDone className='text-white p-[2px] bg-teal-500 rounded-full font-bold text-[18px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2' />
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Team Selection */}
                <div className="space-y-1.5">
                    <label className="text-xs font-semibold text-[#374151] dark:text-[#E5E7EB] tracking-wide">
                        Select team(s)
                    </label>
                    <Select
                        isMulti
                        isClearable
                        isSearchable
                        options={teams}
                        onChange={selectTeams}
                        value={selectedTeams}
                        styles={customStyles}
                        onMenuOpen={() => setIsDropdownOpen(true)}
                        onMenuClose={() => setIsDropdownOpen(false)}
                        components={{ DropdownIndicator, ClearIndicator }}
                        placeholder="Assign to specific Team(s)"
                        menuPlacement='auto'
                        className='assignedRoomTeamList'
                    />
                </div>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-[#E5E7EB] dark:border-[#303B4F] bg-white dark:bg-[#181E28] flex items-center justify-end gap-3">
                <button
                    className="px-4 py-2 text-sm font-medium text-[#6B7280] hover:text-[#374151] dark:text-[#9CA3AF] dark:hover:text-white bg-transparent hover:bg-[#F3F4F6] dark:hover:bg-[#242C3B] rounded-lg transition-all duration-200"
                    onClick={handleClose}
                >
                    Cancel
                </button>
                {loader ? (
                    <button className="px-4 py-2 text-sm font-medium text-white bg-teal-600 rounded-lg opacity-70 cursor-not-allowed flex items-center gap-2">
                        <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                        </svg>
                        {type === 'edit' ? 'Updating...' : 'Creating...'}
                    </button>
                ) : (
                    <button
                        onClick={createTag}
                        disabled={!searchQuery?.trim() || !uniqName || (!isChanged && type === 'edit')}
                        className={`px-4 py-2 text-sm font-medium text-white rounded-lg transition-all duration-200 flex items-center gap-2 ${
                            searchQuery?.trim() && uniqName && (isChanged || type !== 'edit')
                                ? 'bg-btn-primary hover:bg-btn-hover active:bg-[#387440] shadow-sm hover:shadow-md'
                                : 'bg-[#9CA3AF] cursor-not-allowed opacity-60'
                        }`}
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                        {type === 'edit' ? 'Update Tag' : 'Create Tag'}
                    </button>
                )}
            </div>
        </Modal>
    );
};

export default CreateTag;